import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import LangProvider from './context/langContext';
import UserProvider from './context/userContext';
import CartProvider from './context/cartContext';
import CollaborationsProvider from './context/collaborationsContext';
import FiltersProvider from './context/filtersContext';
import CurrencyProvider from './context/currencyContext';

import { Provider } from 'react-redux';
import { PersistGate } from "redux-persist/lib/integration/react";
import { store, persistor } from './store/store';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <LangProvider>
        <CurrencyProvider>
          <UserProvider>
            <FiltersProvider>
              <CartProvider>
                <CollaborationsProvider>
                  <App />
                </CollaborationsProvider>
              </CartProvider>
            </FiltersProvider>
          </UserProvider>
        </CurrencyProvider>
      </LangProvider>
    </PersistGate>
  </Provider >
);


